import React from 'react';
import './HaekelTreff.css';
import HaekelTreffImage from '../assets/img/haekel-treff-winter-hero.webp';
import Crochet01 from '../assets/img/crochet-01.webp';
import Crochet02 from '../assets/img/crochet-02.webp';
import Crochet03 from '../assets/img/crochet-03.webp';
import Crochet04 from '../assets/img/crochet-04.webp';
import Crochet05 from '../assets/img/crochet-05.webp';
import Crochet06 from '../assets/img/crochet-06.webp';
import Crochet07 from '../assets/img/crochet-07.webp';
import Crochet08 from '../assets/img/crochet-08.webp';
import Crochet09 from '../assets/img/crochet-09.webp';
import Crochet10 from '../assets/img/crochet-10.webp';
import Crochet11 from '../assets/img/crochet-11.webp';
import Crochet12 from '../assets/img/crochet-12.webp';
import Crochet13 from '../assets/img/crochet-13.webp';
import Crochet14 from '../assets/img/crochet-14.webp';
import Crochet15 from '../assets/img/crochet-15.webp';
import Crochet16 from '../assets/img/crochet-16.webp';
import Crochet17 from '../assets/img/crochet-17.webp';
import Crochet18 from '../assets/img/crochet-18.webp';
import Crochet19 from '../assets/img/crochet-19.webp';
import Crochet20 from '../assets/img/crochet-20.webp';
import Crochet21 from '../assets/img/crochet-21.webp';
import { siteInfo } from '../data/siteInfo';
import { Seo, buildBreadcrumbSchema } from '../components/Seo';

const crochetImages = [
    Crochet01,
    Crochet02,
    Crochet03,
    Crochet04,
    Crochet05,
    Crochet06,
    Crochet07,
    Crochet08,
    Crochet09,
    Crochet10,
    Crochet11,
    Crochet12,
    Crochet13,
    Crochet14,
    Crochet15,
    Crochet16,
    Crochet17,
    Crochet18,
    Crochet19,
    Crochet20,
    Crochet21
];

const registrationMailHref = `mailto:${siteInfo.email}?subject=${encodeURIComponent('Anmeldung H\u00e4kel-Treff')}`;

const eventSchema = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: "Weihnachtlicher Häkel-Treff im Sarita's",
    description: "Gem\u00fctlicher H\u00e4kel-Treff im Sarita's in Hinwil mit Kaffee, Kuchen, eigenen Projekten, Weihnachts-Startersets und Fragen rund ums H\u00e4keln.",
    url: `${siteInfo.siteUrl}/haekel-treff`,
    startDate: '2026-11-21T11:00:00+01:00',
    endDate: '2026-11-21T16:30:00+01:00',
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
    eventStatus: 'https://schema.org/EventScheduled',
    image: `${siteInfo.siteUrl}${HaekelTreffImage}`,
    location: {
        '@type': 'Place',
        name: siteInfo.name,
        address: {
            '@type': 'PostalAddress',
            streetAddress: siteInfo.streetAddress,
            postalCode: siteInfo.postalCode,
            addressLocality: siteInfo.addressLocality,
            addressCountry: siteInfo.addressCountry
        }
    },
    organizer: {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.siteUrl,
        email: siteInfo.email,
        telephone: siteInfo.phoneIntl
    },
    offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'CHF',
        availability: 'https://schema.org/InStock'
    }
};

function HaekelTreff() {
    return (
        <div className='haekel-page'>
            <Seo
                title='Weihnachtlicher Häkel-Treff'
                description="Weihnachtlicher Häkel-Treff im Sarita's in Hinwil am Samstag, 21. November 2026 von 11:00 bis 16:30 Uhr. Anmeldung bis 19. November per Mail oder Telefon."
                path='/haekel-treff'
                schema={[
                    eventSchema,
                    buildBreadcrumbSchema([
                        { name: 'Startseite', path: '/' },
                        { name: 'Aktuell', path: '/news' },
                        { name: 'H\u00e4kel-Treff', path: '/haekel-treff' }
                    ])
                ]}
            />
            <header
                className='page-hero haekel-hero'
                style={{
                    backgroundImage: `url(${HaekelTreffImage})`
                }}
            >
                <div className='container page-hero__content haekel-hero__content'>
                    <p className='haekel-hero__eyebrow'>Weihnachtlicher Häkel-Treff im Sarita&apos;s</p>
                    <h1 className='page-hero__title'>Kaffee, Kuchen und Häkeln</h1>
                    <p className='haekel-hero__meta'>Samstag, 21. November 2026 &middot; 11:00 - 16:30 Uhr</p>
                </div>
            </header>

            <section className='section-shell'>
                <div className='container'>
                    <div className='haekel-intro panel-surface reveal'>
                        <div className='haekel-intro__copy'>
                            <p className='section-eyebrow'>Gemeinsam kreativ f&uuml;r Weihnachten</p>
                            <h2 className='section-title'>Ein gem&uuml;tlicher Treffpunkt f&uuml;r H&auml;kelfreude</h2>
                            <p>
                                Sarah h&auml;kelt privat mit viel Freude und m&ouml;chte diese Begeisterung mit ihren G&auml;sten teilen.
                                Daraus ist die Idee f&uuml;r den H&auml;kel-Treff entstanden: zusammen Kaffee trinken, Kuchen geniessen,
                                an eigenen Projekten weiterarbeiten und Fragen stellen.
                                Am 21. November stimmen wir uns mit weihnachtlichen Motiven auf die Festtage ein.
                            </p>
                            <p>
                                Der Treff ist offen f&uuml;r alle, die gerne h&auml;keln oder stricken. F&uuml;r Anf&auml;nger:innen stehen
                                Weihnachts-Startersets inklusive Material f&uuml;r CHF 15.- bis 25.- zur Auswahl, je nach Motiv.
                                Du musst nicht die ganze Zeit dabei sein und kannst auch nur f&uuml;r einen Teil des Treffens vorbeikommen.
                            </p>
                            <div className='haekel-intro__actions'>
                                <a href={registrationMailHref} className='btn-sarita'>Per Mail anmelden</a>
                                <a href={siteInfo.phoneHref} className='btn-sarita btn-sarita--ghost'>Telefonisch anmelden</a>
                            </div>
                        </div>

                        <dl className='haekel-event-facts' aria-label='Eventdetails'>
                            <div>
                                <dt>Datum</dt>
                                <dd>Samstag, 21. November 2026</dd>
                            </div>
                            <div>
                                <dt>Zeit</dt>
                                <dd>11:00 - 16:30 Uhr<br/>
                                    (Du kannst auch nur für einen Teil der Zeit dabei sein)</dd>
                            </div>
                            <div>
                                <dt>Anmeldung</dt>
                                <dd>
                                    Bis Donnerstag, 19. November 2026 <br/>per Mail an <a href={`mailto:${siteInfo.email}`}>{siteInfo.email}</a>{' '}
                                    <br/>oder telefonisch unter <a href={siteInfo.phoneHref}>{siteInfo.phone}</a>.
                                </dd>
                            </div>
                            <div>
                                <dt>Teilnahme</dt>
                                <dd>Kostenlos</dd>
                            </div>
                        </dl>
                    </div>

                    <div className='haekel-points'>
                        <article className='haekel-point reveal'>
                            <h3>Mitbringen</h3>
                            <p>Bring deine eigene H&auml;kel- oder Strickarbeit mit und arbeite in entspannter Runde daran weiter.</p>
                        </article>
                        <article className='haekel-point reveal'>
                            <h3>F&uuml;r Neulinge</h3>
                            <p>W&auml;hle ein Weihnachts-Starterset inklusive Material f&uuml;r CHF 15.- bis 25.-, je nach Motiv.</p>
                        </article>
                        <article className='haekel-point reveal'>
                            <h3>Fragen stellen</h3>
                            <p>Sarah beantwortet Fragen rund ums H&auml;keln, hilft dir weiter und bietet Anleitungen f&uuml;r verschiedene Weihnachtssujets.</p>
                        </article>
                    </div>
                </div>
            </section>

            <section className='section-shell haekel-gallery-section'>
                <div className='container'>
                    <header className='haekel-gallery-header'>
                        <p className='section-eyebrow text-center'>Sarahs Handarbeit</p>
                        <h2 className='section-title text-center'>H&auml;kelideen als Inspiration</h2>
                        <p>
                            Entdecke einige von Sarahs bisherigen Arbeiten. Beim Weihnachts-Treff stehen weihnachtliche Motive und passende Anleitungen bereit.
                        </p>
                    </header>
                    <div className='haekel-crochet-grid'>
                        {[...crochetImages].reverse().map((image, index) => (
                            <figure className='haekel-crochet-item reveal' key={image}>
                                <img
                                    src={image}
                                    alt={`H\u00e4keltarbeit von Sarah, Variante ${index + 1}`}
                                    loading='lazy'
                                />
                            </figure>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default HaekelTreff;
